import { useEffect as f } from "react";
const h = ({ handleRef: a, modalRef: c }) => {
  f(() => {
    const t = a.current;
    let r = !1, s = 0, i = 0;
    const l = (e) => {
      r = !0, s = e.touches[0].screenY;
    }, u = (e) => {
      if (!r || !t)
        return;
      const o = t.closest(".modal-content");
      if (!o)
        return;
      const n = i = e.touches[0].screenY, m = n > s ? n - s : 0;
      o.style.transition = "none", o.style.transform = `translateY(${m}px)`;
    }, d = () => {
      if (r = !1, !t)
        return;
      const e = t.closest(".modal-content");
      if (!e)
        return;
      i - s > 50 ? (e.style.transition = "transform 0.1s ease-in-out", e.style.transform = `translateY(${e.clientHeight}px)`, setTimeout(() => {
        var n;
        (n = c.current) == null || n.close();
      }, 100)) : (e.style.transition = "transform 0.1s ease-in-out", e.style.transform = "translateY(0px)");
    };
    return t && (t.addEventListener("touchstart", l), t.addEventListener("touchmove", u), t.addEventListener("touchend", d)), () => {
      t && (t.removeEventListener("touchstart", l), t.removeEventListener("touchmove", u), t.removeEventListener("touchend", d));
    };
  }, [a.current, c]);
};
export {
  h as default
};
